class Carousel extends HTMLElement {

  connectedCallback() {
    this.initSlider()
  }

  initSlider() {
    const swiperEl = this.querySelector('swiper-container');

    const swiperParams = {
      slidesPerView: 1.8,
      spaceBetween: 30,
      breakpoints: {
        990: {
          slidesPerView: 2.15,
          spaceBetween: 60,
        },
      },
      navigation: {
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      },
    };

    Object.assign(swiperEl, swiperParams);
    swiperEl.initialize();
  }
}

window.customElements.define('page-carousel', Carousel)
